import { useField } from 'formik';
import React, { useCallback } from 'react';
import {
  Checkbox,
  FieldSet,
  Label,
  LabeledControl,
  Legend,
  List,
  Paragraph,
  Tooltip,
  TooltipPopper,
} from '@zillow/constellation';

export const StatusExclusionFilter: React.FC = () => {
  const [, , statusesHelpers] = useField<string[]>({ name: 'orderStatuses' });
  const [excludeCanceledField, , excludeCanceledHelpers] = useField<boolean>({
    name: 'excludeCanceledOrders',
  });
  const [excludeInactiveField, , excludeInactiveHelpers] = useField<boolean>({
    name: 'excludeInactiveOrders',
  });

  const onChangeCancelled = useCallback(() => {
    if (!excludeCanceledField.value) {
      statusesHelpers.setValue([]);
    }
    excludeCanceledHelpers.setValue(!excludeCanceledField.value);
    excludeInactiveHelpers.setValue(false);
  }, [statusesHelpers, excludeCanceledHelpers, excludeInactiveHelpers, excludeCanceledField.value]);

  const onChangeInactive = useCallback(() => {
    if (!excludeInactiveField.value) {
      statusesHelpers.setValue([]);
    }
    excludeInactiveHelpers.setValue(!excludeInactiveField.value);
    excludeCanceledHelpers.setValue(false);
  }, [statusesHelpers, excludeCanceledHelpers, excludeInactiveHelpers, excludeInactiveField.value]);

  return (
    <FieldSet legend={<Legend>Status Exclusion Rules</Legend>}>
      <LabeledControl
        label={
          <Label>
            Exclude Cancelled <CanceledTooltip />
          </Label>
        }
        control={<Checkbox checked={excludeCanceledField.value} onChange={onChangeCancelled} />}
      />
      <LabeledControl
        label={
          <Label>
            Exclude Inactive <InactiveTooltip />
          </Label>
        }
        control={<Checkbox checked={excludeInactiveField.value} onChange={onChangeInactive} />}
      />
    </FieldSet>
  );
};

const CanceledTooltip: React.FC = () => {
  return (
    <TooltipPopper
      triggered={<Tooltip body={<Paragraph>Cancelled Orders have the order status "Cancelled"</Paragraph>} />}
    />
  );
};

const InactiveTooltip: React.FC = () => {
  return (
    <TooltipPopper
      triggered={
        <Tooltip
          body={
            <>
              <Paragraph>Inactive Orders have one of the the following order statuses:</Paragraph>
              <List>
                <List.Item>Funded</List.Item>
                <List.Item>Recorded</List.Item>
                <List.Item>Funded and Recorded</List.Item>
                <List.Item>Policy Issued</List.Item>
                <List.Item>Complete</List.Item>
                <List.Item>Cancelled</List.Item>
              </List>
            </>
          }
        />
      }
    />
  );
};
